import t from"./link";export{StyledLink,StyledLinkIcon}from"./link.styles";export default t;